<template>
  <div>
    <div :class="$style.container">
      <div :class="$style.thumbnail">
        <IconPlay
          :class="$style.playIcon"
          alt="Play Icon"
          @click="shouldOpenModal = true"
        />

        <AspectRatio ratio="293x165">
          <BasePicture
            v-if="data?.fields?.videoThumbnail?.fields?.file?.url"
            :src="data?.fields?.videoThumbnail?.fields?.file?.url"
            alt=""
            @click="shouldOpenModal = true"
          />
        </AspectRatio>
      </div>

      <h6 :class="$style.videoTitle">{{ data?.fields?.videoTitle }}</h6>
    </div>

    <BaseModal
      :is-open="shouldOpenModal"
      overlay-color="rgba(255, 255, 255, 0.8)"
      @request-close="shouldOpenModal = false"
    >
      <div :class="$style.modalContainer" @click="shouldOpenModal = false">
        <div :class="$style.modal">
          <BaseButton
            :class="$style.closeBtn"
            :aria-label="localizedStrings['close-modal'] || 'Close Modal'"
            presentation="strip"
            @click.stop="shouldOpenModal = false"
          >
            <IconTimes :class="$style.timesIcon" alt="" />
          </BaseButton>
          <BaseVideoIframe
            v-if="data?.fields?.videoEmbed"
            :src="data?.fields?.videoEmbed"
          />
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script setup lang="ts">
import type { TypeAsideCardWithoutUnresolvableLinksResponse } from '~/types/contentful'

const { localizedStrings } = useLocalizedStrings()

defineProps<{
  data: TypeAsideCardWithoutUnresolvableLinksResponse
}>()

const shouldOpenModal = ref(false)
</script>

<style lang="scss" module>
.container {
  @include fluid-type(21px, 23px);
  padding: 20px 20px 32px;
}

.videoTitle {
  @include fluid-type(20px, 25px);
  font-family: var(--roboto-condensed);
  line-height: math.div(30, 25);
  margin-top: 13px;
}

.thumbnail {
  position: relative;
  cursor: pointer;
}

.playIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--white);
  z-index: 10;
  width: 50px;
  height: 50px;
}

.modalContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-width: 900px;
  width: 90%;
  margin: 0 auto;
}

.modal {
  position: relative;
  width: 100%;
  max-height: 80%;
}

.closeBtn {
  position: absolute;
  top: -40px;
  right: 0;
}

.timesIcon {
  color: var(--purple);
  width: 25px;
  height: 25px;
}
</style>
